import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Terminal16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.93928 7.49996L4.46962 6.03034L5.53026 4.96967L8.0606 7.49994L5.53028 10.0303L4.4696 8.96968L5.93928 7.49996Z'
      fill='currentColor'
    />
    <path d='M8.49994 10.75H11.9999V9.25H8.49994V10.75Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.25 2.42851C1.25 1.7776 1.77766 1.24994 2.42857 1.24994H13.5714C14.2223 1.24994 14.75 1.7776 14.75 2.42851V13.5714C14.75 14.2223 14.2223 14.7499 13.5714 14.7499H2.42857C1.77766 14.7499 1.25 14.2223 1.25 13.5714V2.42851ZM2.75 2.74994V13.2499H13.25V2.74994H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Terminal16.displayName = 'Terminal16';
export default Terminal16;
